export default {
  SHORT: 'short',
  MEDIUM: 'medium'
};